import { BusinessSettingsModel, businessSettingsApi } from '@pukka/api';
import { PageContainer, Switch } from '@pukka/ui-components';
import { DefaultActionBar } from '@pukka/ui-composite';
import { useMutation, useQuery } from '@tanstack/react-query';

import infoIcon from './ic-info.svg';

function CustomerDisplaySettings() {
  const { data: businessSettingsData, refetch } = useQuery(['business-settings'], businessSettingsApi.getSettings);
  const { mutate: updateBusinessSettings } = useMutation(businessSettingsApi.updateSettings, {
    onSuccess: () => {
      refetch();
    },
  });

  const businessSettings: BusinessSettingsModel.Setting = businessSettingsData?.data?.setting;
  const isFeedbackEnabled = businessSettings?.cds_feedback;

  const handleSwitchChange = async (checked: boolean) => {
    const setting = {
      ...businessSettings,
      cds_feedback: checked,
    };

    updateBusinessSettings({ setting });
  };

  return (
    <PageContainer>
      <DefaultActionBar pageTitle="Customer Display Settings" />
      <div className="flex flex-col gap-6 text-neutral-700 lg:w-1/2">
        <div className="border-b border-b-neutral-300 pb-2 text-lg font-medium">Feedback</div>
        <div className="flex items-center gap-16">
          <div>
            <div className="font-medium">Enable CRM Feedback</div>
            <div>When turned on, customers can give feedback directly to customer facing display</div>
          </div>
          <div>
            <Switch variant="rect" checked={isFeedbackEnabled} onCheckedChange={handleSwitchChange} />
          </div>
        </div>
        <div className="flex items-center gap-2 rounded border border-yellow-300 bg-yellow-100 p-4 text-sm">
          <img src={infoIcon} alt="info" />
          <div>This feature currently only works on Moka Prime</div>
        </div>
        <hr />
      </div>
    </PageContainer>
  );
}

export { CustomerDisplaySettings as default };
